module.exports = __webpack_public_path__ + "fonts/font.0fb9c2c.woff2";